export class Releases {
    public id: string;
    public name: string;
    public idioma: string;
    public valid: boolean;
}
